export default __webpack_public_path__ + "260d1d7d232130c84e385a903ed78591.png";